module.exports = __webpack_public_path__ + "static/media/Sharp-LQ121K1LG52-Mechanical-Drawing.83ad8bf2.gif";